import axios from 'axios';

// Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    // Return response for successful requests
    return response;
  },
  (error) => {
    // Check if error response exists and status is 401 (Unauthorized)
    if (error.response && error.response.status === 401) {
      // Don't auto-logout if we are already on the login page 
      // or if it's a login attempt (which naturally returns 401 for invalid credentials)
      const isLoginRequest = error.config.url.includes('/auth/');
      const isLoginPage = window.location.pathname === '/login' || window.location.pathname === '/respondent-login';

      if (!isLoginRequest && !isLoginPage) {
        console.log('Token expired or unauthorized. Logging out...');
        
        // Clear authentication data from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        
        // Use window.location.href for a full page reload and redirect
        // This ensures the application state is completely reset
        window.location.href = '/login';
      }
    }
    
    // Return the error so it can still be handled by the caller if needed
    return Promise.reject(error);
  }
);

// We can also set a base URL and add a request interceptor here 
// to automatically include the token in all requests, 
// which would clean up the code even more.
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      // If we already have a token, add it to the headers
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
